import React from 'react'
import { BaseRouteParams } from 'hocs'
import { useParams } from 'react-router-dom'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { removeHash } from 'utils/hash'
import {
    useRedeemUnusedDiscountCodesFromCodeMutation,
    useRedeemUnusedDiscountCodesFromUploadsMutation,
} from 'discounts/reduxQuery'
import { showErrorMessage } from 'uiComponents/message'

interface RedeemCodesProps {
    codeUuid: string
    codeType: 'upload' | 'code'
}

export const RedeemCodes: React.FC<RedeemCodesProps> = ({ codeUuid, codeType }) => {
    const [redeemUploads, { isLoading: isRedeemingUploads }] = useRedeemUnusedDiscountCodesFromUploadsMutation()
    const [redeemCodes, { isLoading: isRedeemingCodes }] = useRedeemUnusedDiscountCodesFromCodeMutation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const isRedeeming = isRedeemingUploads || isRedeemingCodes

    const onConfirm = () => {
        let response: Promise<any> | null = null

        if (codeType === 'upload') {
            response = redeemUploads({
                accountSlug,
                uuid: codeUuid,
            }).unwrap()
        }

        if (codeType === 'code') {
            response = redeemCodes({
                accountSlug,
                uuid: codeUuid,
            }).unwrap()
        }

        if (response) {
            response
                .catch((res: any) => {
                    showErrorMessage(res?.error?.message || 'Failed to redeem unused codes', 'redeem_error')
                })
                .finally(removeHash)
        }
    }
    return (
        <ConfirmationDialog
            title="Redeem unused codes"
            text={<>Are you sure you want to redeem unused codes? They will no longer be usable.</>}
            buttonText="Redeem"
            loading={isRedeeming}
            onConfirm={onConfirm}
            onCancel={removeHash}
        />
    )
}
